import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Row,
  Col,
  DatePicker,
  Select,
  Divider,
  UploadFile,
  FormInstance,
  Typography,
  Image,
  Avatar,
} from "antd";
import ImageUpload from "../../../Common/ImageUpload";
import { useTranslation } from "react-i18next";
import { UserCreateParams, UserParams } from "../../../../hooks/api/users";
import AlternativePhoneInput from "../../../Common/AlternativePhoneInput";
import { UserOutlined } from "@ant-design/icons";
import VaadMembershipsSection, {
  VaadMembership,
} from "./VaadMembershipsSection";

export interface UsersFormProps {
  initialValues?: UserParams;
  form?: FormInstance<UserParams>;
  onSubmit?: (values: UserParams) => void | Promise<void>;
  fileList?: UploadFile[];
  setFileList: React.Dispatch<React.SetStateAction<UploadFile[]>>;
  memberships: VaadMembership[];
  availableVaads: { id: string; name: string }[];
  onMembershipsChange: (memberships: VaadMembership[]) => void;
  onSubscriptionCanceled?: () => void;
}

export default function UsersForm({
  // form,
  initialValues,
  fileList,
  setFileList,
  onSubmit,
  memberships,
  availableVaads,
  onMembershipsChange,
  onSubscriptionCanceled,
}: UsersFormProps): React.ReactElement {
  const form = Form.useFormInstance();
  const { t } = useTranslation();

  const mainFields = [
    {
      name: "fullName",
      label: t("pages.users.form.name"),
      required: true,
      component: <Input />,
      rules: [
        {
          required: true,
        },
        {
          min: 3,
          max: 150,
        },
        {
          pattern: /^[A-Za-zÀ-ž\s'-]+$/,
        },
      ],
    },
    {
      name: "phone",
      label: t("pages.users.form.phoneNumber"),
      component: (
        <AlternativePhoneInput
          placeholder={t("pages.users.form.enterPlaceholder")}
        />
      ),
    },
    {
      name: "email",
      label: t("pages.users.form.email"),
      required: true,
      component: (
        <Input disabled placeholder={t("pages.users.form.enterPlaceholder")} />
      ),
      rules: [
        {
          required: true,
        },
        {
          type: "email",
        },
      ],
    },
    {
      name: "address",
      label: t("pages.users.form.address"),
      component: <Input placeholder={t("pages.users.form.enterPlaceholder")} />,
    },
  ];

  const renderFields = (fields: any[]) =>
    fields.map((f) => (
      <Col span={12} key={f.name}>
        <Form.Item name={f.name} label={f.label} rules={f.rules}>
          {f.component}
        </Form.Item>
      </Col>
    ));

  return (
    <>
      <Row gutter={24}>
        <Col span={4} style={{ textAlign: "center" }}>
          <Avatar
            size={120}
            src={form.getFieldValue("photoUrl") || null}
            // avatar={userData?.photoUrl}
            icon={<UserOutlined />}
          />
          <h4 style={{ textAlign: "center", marginTop: 24 }}>
            {form.getFieldValue("fullName")}
          </h4>
        </Col>
        <Col span={20}>
          <Row>
            <Typography.Text
              strong
              style={{ fontSize: 16, margin: "20px 16px" }}
            >
              Contact Information
            </Typography.Text>
          </Row>

          <Row gutter={16}>{renderFields(mainFields)}</Row>

          <VaadMembershipsSection
            memberships={memberships}
            availableVaads={availableVaads}
            onMembershipsChange={onMembershipsChange}
            onSubscriptionCanceled={onSubscriptionCanceled}
          />
        </Col>
      </Row>
    </>
  );
}
